import { useMemo, useCallback } from 'react'
import startOfDay from 'date-fns/startOfDay'
import sub from 'date-fns/sub'

import { useBookingContext } from '@providers/booking'
import { MultipleDatePicker } from '@components/multiple_date_picker'

export const DatePicker = () => {
  const bookingCtx = useBookingContext()
  const { state: booking } = bookingCtx
  const endDate = sub(booking.endDate!, { days: 1 })

  const onCheckAvailableDate = useCallback(
    (day: Date) => {
      const idx = booking.data.offerAvailability?.findIndex(({ id }) => id === day.getTime()) ?? -1
      if (idx < 0) {
        return false
      }
      return !booking.data.offerAvailability![idx].availability.availabilities![0].available
    },
    [booking.data.offerAvailability]
  )

  const onChangeDateValue = useCallback(
    (selectedDate: Date | null) => {
      if (!selectedDate) {
        bookingCtx.dispatch({ type: 'SET_DAYCARE_DATES', payload: { value: null } })
        return
      }
      bookingCtx.dispatch({ type: 'SET_DAYCARE_DATES', payload: { value: startOfDay(selectedDate) } })
    },
    [bookingCtx]
  )

  const dates = useMemo(
    () => booking.cart.groups[0].daycareSelected?.map(({ date }) => date) ?? [],
    [booking.cart.groups]
  )

  return (
    <MultipleDatePicker
      selectedDates={dates}
      minDate={booking.startDate}
      maxDate={endDate}
      onChange={onChangeDateValue}
      shouldDisableDate={onCheckAvailableDate}
    />
  )
}
